import { render, staticRenderFns } from "./page-skeleton.vue?vue&type=template&id=0cd5a0b3&scoped=true&lang=pug&"
import script from "./page-skeleton.vue?vue&type=script&lang=js&"
export * from "./page-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./page-skeleton.vue?vue&type=style&index=0&id=0cd5a0b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd5a0b3",
  null
  
)

export default component.exports